module.exports = __webpack_public_path__ + "img/02.ba25d937.png";